// extracted by mini-css-extract-plugin
export default {"page":"user_page__8fssZ","logout":"user_logout__SReaM","whitespce":"user_whitespce__Qyv1C","primary_color":"user_primary_color__dyn0t"};